import fetch from "@/uilts/request";


// 深圳风控报告
export default {
  /**
   * 创建授权书
   */
  createAuthorization(data) {
    return fetch.post("CreditReporting/createTemp", data)
  },
  previewFileId20(data) {
    return fetch.post("CreditReporting/previewFileId20", data)
  },
  previewFileId21(data) {
    return fetch.post("CreditReporting/previewFileId21", data)
  },
  downFileId20(data) {
    return fetch.post("CreditReporting/downFileId20", data)
  },
  downFileId21(data) {
    return fetch.post("CreditReporting/downFileId21", data)
  },
  details(data) {
    return fetch.post("CreditReporting/details", data)
  },
  jiaBan(data) {
    return fetch.post("CreditReporting/JiaBan", data)
  },
  jiaBanSubmit(data) {
    return fetch.post("CreditReporting/JiaBanSubmit", data)
  },
  jiaBanQuery(data) {
    return fetch.post("CreditReporting/jiaBanQuery", data)
  },
  sjxTestGenOpen(data) {
    return fetch.post("CreditReporting/sjxTestGenOpen", data)
  },
  sjxTestGen(data) {
    return fetch.post("CreditReporting/sjxTestGen", data)
  },
  sjxGetGetResult(data) {
    return fetch.post("CreditReporting/sjxGetGetResult", data)
  },
   /**
   * ZCI127 - 获取征信信息（有缓存结果直接返回，否则自动申请）
   * @param {{ order_id: string|number }} data
   * @returns data: reportUrl 字符串
   */
  zci127Open(data) {
    return fetch.post("CreditReporting/zci127Open", data)
  },

  /**
   * ZCI127 - 申请征信查询（服务端按 order_id 组装必填参数后直调）
   * 服务端组装: name, idCard, phone, certFileFront, certFileReverse, power, grantAuthorizationDate
   * @param {{ order_id: string|number }} data
   * @returns data: reportUrl 字符串
   */
  zci127Submit(data) {
    return fetch.post("CreditReporting/zci127Submit", data)
  }

}




